var rateUtility = {
    init: function () {
        $('body').on('click', '.utilite-avis a', function () {
            var $utiliteAvis = $(this).closest('.utilite-avis');
            var idProduct = $utiliteAvis.data('id-product');
            var idReview = $utiliteAvis.data('id-review');
            var reviewUseful = $(this).data('review-useful');

            rateUtility.sendRate(idProduct, idReview, reviewUseful);
            return false;
        });
    },

    /**
     * Enregistre le jugement d'un avis d'un internaute.
     */
    sendRate: function (idProduct, idReview, reviewUseful) {
        $.post('/websvc/produit_avis_utile.ws.php', {
            'idproduit': idProduct,
            'idavis': idReview,
            'avisutile': reviewUseful
        })
            .done(function (data, status, xhr) {
                if (data.reponse) {
                    var $avis = $('.line-review').has('[data-id-review="' + idReview + '"]');
                    var phraseInfo = __('avisUtile', data.nb_vote.oui);

                    $avis.find('.libelle_suravis').html(data.msg_reponse);
                    $avis.find('.utilite-avis a').remove();
                    $avis.find('.info_suravis').html(phraseInfo);
                }
            });

    }
};

(function ($) {
    rateUtility.init();
})(jQuery);